import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import Draggable from "react-draggable";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useCart } from "react-use-cart";
import toast from "react-hot-toast";
import axiosInstance, { Homeurl } from "../../axiosInstance";
import { Swiper, SwiperSlide } from "swiper/react";
import Magnifier from "../components/extra/Magnifier";

import QuantitySelector from "../components/extra/QuantitySelector";

// import required modules
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import { useBlogContext } from "../../fetchdata/BlogContext";
import { Helmet } from "react-helmet";
import getCookie from "../../helper/getCookie";
import CreateSlug from "../components/extra/CreateSlug";
import getDecryptData from "../../helper/getDecryptData";

const ProductSlug = () => {


  const navigate = useNavigate();

  const [layout, setLayout] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isProducts, setIsProducts] = useState(true);

  const [Products, setProducts] = useState([]);

  

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state

  const [SubmitWishlist, setWishlistLoading] = useState(true); // Add loading state

  const [SubmitCompare, setCompareLoading] = useState(true); // Add loading state

  const {
    Headers,
    isHeader,
    addItemToCart,
    cartItems,
    promoCodeInfo,
    updateItemQuantity,
  } = useBlogContext();

  const [selectedValues, setSelectedValues] = useState([]);

  const [ValuesVariant, setValuesVariant] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const [selectedCombination, setSelectedCombination] = useState({});

  const [ProductsRegular, setProductsRegular] = useState(0);
  const [ProductsSale, setProductsSale] = useState(0);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const { id, slug } = useParams();

  const [formData, setFormData] = useState({
    
    productId: id,
    rating: "",
    comment: "",
  });

  useEffect(() => {
    setIsLoading(true);
    setIsProducts(true);
    // Update the productId in the formData when id changes
    setFormData((prevState) => ({
      ...prevState,
      productId: id,
      rating: "",
      comment: "",
    }));
  }, [id]); // This useEffect will re-run whenever id changes

  const [selectedColor, setSelectedColor] = useState(""); // State to hold the selected color

  const [pdfBase64, setPdfBase64] = useState(""); // State to hold the PDF as Base64 string

  const [SelectedSizes, setSelectedSizes] = useState({});
  const [TotalQuantity, setTotalQuantity] = useState(1);

  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [thumbsVarSwiper, setThumbsVarSwiper] = useState(null);

  const [isOpenReview, setIsOpenReview] = useState(false);
  const [activeData, setActiveData] = useState([]);

  const toggleReviewPopup  = async ()   => {
        const decryptdatajson = await getDecryptData();
        const   userId = decryptdatajson?._id 

    if (userId) {
      setIsOpenReview(!isOpenReview);
    } else {
      toast.error("Please Login First", TotalQuantity);
    }
  };

  const getProducts = async () => {
       const decryptdatajson = await getDecryptData();
            if (decryptdatajson && decryptdatajson?._id) {
     
              setEnquireData((prevData) => ({
                ...prevData,
                fullname: decryptdatajson.username,
                email: decryptdatajson.email,
                phone: decryptdatajson.phone,
    
              })); // Clear form fields
            }
            
    try {
      const { data } = await axiosInstance.get("/all-home-products");
      setProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  const getData = async () => {
    try {
      const { data } = await axiosInstance.get(`/home-layout-data`);
      setLayout(data.homeLayout);
      setIsLoading(false); // Set loading state to false in case of an error
    } catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getData();
    getProducts();

    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(
    //     function (position) {
         
    //        setEnquireData((prevData) => ({
    //         ...prevData,
    //         latitude: position.coords.latitude,
    //         longitude: position.coords.longitude,
    //       })); // Clear form fields

    //       console.log("Latitude:", position.coords.latitude);
    //       console.log("Longitude:", position.coords.longitude);
    //     },
     
    //   );
    // } else {
    //   toast.error('Geolocation is not supported by this browser.');
    //   return null;
    //  }


  }, [slug]);

  const handleAddToCart = async (product, buy) => {
    // if (!selectedColor) {
    //   toast.error("Please select a color");
    // } else if (!TotalQuantity) {
    //   toast.error("Please select a Quantity", TotalQuantity);
    // } else { }

    const existingProduct = cartItems.find((item) => item.id === product.id);
    if (existingProduct) {
      // const updatedQuantity = existingProduct.quantity + 1;
      const updatedQuantity = TotalQuantity;
      console.log("updatedQuantity", updatedQuantity);

      updateItemQuantity(
        existingProduct.id,
        cartItems.find((item) => item.id === existingProduct.id).quantity +
        updatedQuantity
      );

      if (buy) {
        navigate("/checkout");
      }
      toast.success("Product quantity updated in cart");
    } else {
      await addItemToCart(
        { ...product, color: selectedColor, TotalQuantity },
        TotalQuantity
      );

      // updateItemQuantity(product.id, updatedQuantity);

      if (buy) {
        navigate("/checkout");
      }
      // toast.success("Product Added To Cart");
    }
  };

  const handleBuyNow = (product) => {
    const buy = TotalQuantity;
    handleAddToCart(product, buy);
  };

  const [frontImage, setFrontImage] = useState(null);
  const [overlayImage, setOverlayImage] = useState(null);
  const overlayRef = useRef(null);
  const [overlayPosition, setOverlayPosition] = useState({ x: 0, y: 0 });
  const [overlaySize, setOverlaySize] = useState({ width: 200, height: 200 });
  const [isResizing, setIsResizing] = useState(false);
  const [resizeStart, setResizeStart] = useState({ x: 0, y: 0 });
  const [resizeStartSize, setResizeStartSize] = useState({
    width: 0,
    height: 0,
  });

  const [text, setText] = useState("");
  const [textPosition, setTextPosition] = useState({ x: 10, y: 10 });
  const [isTextDragging, setIsTextDragging] = useState(false);
  const [textColor, setTextColor] = useState("#000000");
  const [textSize, setTextSize] = useState(16);

  const [loading, setLoading] = useState(true); // Add loading state
  const [Image, setImage] = useState("");
  const [Specifications, setspecifications] = useState([]);

  const [mainImage, setMainImage] = useState("");

  const [Product, setProduct] = useState({});
  const [Attr, setAttr] = useState([]);
  const [sizeQuantities, setSizeQuantities] = useState({});
  const [variations, setVariations] = useState([]);
  const [Images, SetImages] = useState([]);

  const [variationsSize, setVariationsSize] = useState([]);
  const [Testimonial, setTestimonial] = useState([]);

  const [Varloading, SetVarLoading] = useState(true); // Add loading state
  const [ratings, setRatings] = useState([]);
  const [totalRating, settotalRating] = useState("");
  const [averageRating, setaverageRating] = useState("");
  const [HSNvariations, setHSNVariations] = useState({});
  const [selectedVariation, setSelectedVariation] = useState(null);

  const [variationsmap, setVariationsmap] = useState([]);
  const [prohsn, setprohsn] = useState("");

  const [activevariations, setactiveVariations] = useState({});

  const handleSmallImageClick = (newImageSrc) => {
    setFrontImage(newImageSrc);
  };

  const [enquireData, setEnquireData] = useState([]);

  const getProduct = async () => {
    window.scrollTo(0, 0);
    setLoading(true); // Set loading to false when data is fetched
    SetVarLoading(true);

    console.log('__PRELOADED_DATA__', window.__PRELOADED_DATA__?.slug, slug);
    if (window.__PRELOADED_DATA__?.slug !== slug || window.__PRELOADED_DATA__ === undefined) {
      try {
        const { data } = await axiosInstance.get(`/user-product-slug/${slug}`);
        setProduct(data.Product);
        // setVariations(data.Product.variations.Color || []);
        // setVariationsSize(data.Product.variations.Size);
        SetImages(data.Product.images);
        setFrontImage(data.Product.pImage);
        setspecifications(data.Product.specifications.specifications || []);
        setSelectedValues(data.Product.variations);

        setEnquireData((prevData) => ({
          ...prevData,
          service: data.Product?.title,
          category: data.Product?.Category,
        })); // Clear form fields
         setprohsn(data.Product.hsn || "");
        setActiveData(data.Product.variations);
        setValuesVariant(data.Product?.variant_products);
        setProductsRegular(data.Product?.regularPrice || 0);
        setProductsSale(data.Product?.salePrice || 0);
        setTestimonial(data.Product?.testimonials || [])
        const firstVisibleProduct = data.Product?.variant_products && data.Product?.variant_products.find(
          (product) => product.visible === true
        );

        if (firstVisibleProduct) {
          const {
            regular_price,
            sale_price,
            qty,
            visible,
            images,
            ...filteredProduct
          } = firstVisibleProduct;

          setSelectedCombination(filteredProduct);

          console.log("firstVisibleProduct", filteredProduct);
        }
      } catch (error) {
        console.error("Error getting product:", error);
        navigate("/404");
      } finally {
        setLoading(false); // Set loading to false when data is fetched
        SetVarLoading(false);
        console.log("Image", Image);
      }
    } else {
      setLoading(false); // Set loading to false when data is fetched
      SetVarLoading(false);
      setIsLoading(false);

      setProduct(window.__PRELOADED_DATA__);
      // setVariations(data.Product.variations.Color || []);
      // setVariationsSize(data.Product.variations.Size);
      SetImages(window.__PRELOADED_DATA__.images);
      setFrontImage(window.__PRELOADED_DATA__.pImage);
      setspecifications(window.__PRELOADED_DATA__.specifications.specifications || []);
      setSelectedValues(window.__PRELOADED_DATA__.variations);
      setTestimonial(window.__PRELOADED_DATA__.testimonials || []);

      setEnquireData((prevData) => ({
        ...prevData,
        service: window.__PRELOADED_DATA__?.title,
      })); // Clear form fields

      // console.log("product data", data);
      setprohsn(window.__PRELOADED_DATA__.hsn || "");
      setActiveData(window.__PRELOADED_DATA__.variations);
      setValuesVariant(window.__PRELOADED_DATA__?.variant_products);
      setProductsRegular(window.__PRELOADED_DATA__?.regularPrice || 0);
      setProductsSale(window.__PRELOADED_DATA__?.salePrice || 0);
      const firstVisibleProduct = window.__PRELOADED_DATA__?.variant_products.find(
        (product) => product.visible === true
      );

      if (firstVisibleProduct) {
        const {
          regular_price,
          sale_price,
          qty,
          visible,
          images,
          ...filteredProduct
        } = firstVisibleProduct;

        setSelectedCombination(filteredProduct);

        console.log("firstVisibleProduct", filteredProduct);
      }

      setLoading(false); // Set loading to false when data is fetched
      SetVarLoading(false);

    }


  };

  const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/view-product-rating/${Product._id}`);
      console.log("rating", data);
      const myrating = data.productRatings.reverse();
      setRatings(myrating);
      hasUserReviewed();

      // Calculate total rating
      const totalRating = data.productRatings.length;
      settotalRating(totalRating);

      // Calculate average rating
      const averageRating =
        totalRating > 0
          ? data.productRatings.reduce(
            (acc, rating) => acc + rating.rating,
            0
          ) / totalRating
          : 0;
      setaverageRating(averageRating);
    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };
  const hasUserReviewed = async () => {
     const decryptdatajson = await getDecryptData();
        const   userId = decryptdatajson?._id;
    const reviewedRating = ratings.find((rating) => rating.userId === userId);
    const hasReviewed = !!reviewedRating; // Convert to boolean
    // console.log('User has reviewed:', hasReviewed);
    return hasReviewed;
  };

  const getAttribute = async () => {
    try {
      const { data } = await axiosInstance.get("/all-attribute");
      console.log("attr", data);
      setAttr(data.Attribute);
    } catch (error) {
      console.error("Error fetching attributes:", error);
    }
  };

  const handleIncrement = (stock) => {
    if (TotalQuantity <= stock) {
      // Check input length before updating

      setTotalQuantity(TotalQuantity + 1);
    } else {
      toast.error("Product out of stock. ");
    }
  };

  const handleDecrement = () => {
    if (TotalQuantity > 1) {
      setTotalQuantity(TotalQuantity - 1);
    }
  };

  const handleQuantityChange = (event) => {
    const newQuantity = parseInt(event.target.value);
    if (!isNaN(newQuantity) && newQuantity >= 1) {
      setTotalQuantity(newQuantity);
    }
  };

  useEffect(() => {
    setVariationsmap([]);
    getProduct();
    getAttribute();
  }, [slug]);
  useEffect(() => {
    getRating();
 }, [Product._id,]);
  // product zoom js

  const [isZoomed, setIsZoomed] = useState(false);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [hoveredProduct, setHoveredProduct] = useState(null);

  const handleMouseEnter = (product) => {
    setIsZoomed(true);
    setHoveredProduct(product);
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
    setHoveredProduct(null);
  };

  const handleMouseMove = (e) => {
    setCursorPosition({
      x: (e.nativeEvent.offsetX / e.target.offsetWidth) * 100,
      y: (e.nativeEvent.offsetY / e.target.offsetHeight) * 100,
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const AddWhishlistData = async () => {
    setWishlistLoading(false);

    if (formData.userId === "") {
      toast.error("Please Login First");
      setWishlistLoading(true);
    } else {
      try {
        await axiosInstance.post("/add-wishlist", formData);
        toast.success("wishlist Added successfully!");
      } catch (error) {
        console.error("Error on wishlist added:", error);
        toast.error(error.response.data.message);
      } finally {
        setWishlistLoading(true);
      }
    }
  };

  const AddCompareData = async () => {
    setCompareLoading(false);

    if (formData.userId === "") {
      toast.error("Please Login First");
      setCompareLoading(true);
    } else {
      try {
        await axiosInstance.post("/add-compare", formData);
        toast.success("Comparsion Added successfully!");
      } catch (error) {
        console.error("Error on compare added:", error);
        toast.error(error.response.data.message);
      } finally {
        setCompareLoading(true);
      }
    }
  };

  const submitData = async () => {
    setSubmitLoading(false);

    if (formData.userId === "") {
      toast.error("Please Login First");
      setSubmitLoading(true);

      return;
    } else {
        const decryptdatajson = await getDecryptData();
        const   userId = decryptdatajson?._id 
        
      if (formData.rating !== "" || formData.comment !== "") {
 
       const finalData = {
    ...formData,
    userId,
    productId: Product._id,
  };

        try {
          await axiosInstance.post("/add-rating", finalData);
          toggleReviewPopup();
          toast.success("Rating Added successfully!");
          getRating();
        } catch (error) {
          console.error("Error on rating added:", error);
          toast.error(error.response.data.message);
          setRatings([]);
        } finally {
          setSubmitLoading(true);
        }
      } else {
        toast.error("Please Fill All Fields");
        setSubmitLoading(true);
      }
    }
  };

  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  }

  const [MatchImages, setMatchImages] = useState([]);
  const [ProductVariantName, setProductVariantName] = useState("");
  const [ProductuniqueId, setProductuniqueId] = useState("");

  // Function to handle button click and update selected variant
  // Function to handle button click and update selected variant
  const handleVariantButtonClick = (name, value) => {
    const newSelectedCombination = { ...selectedCombination, [name]: value };
    setSelectedCombination(newSelectedCombination);
  };

  useEffect(() => {
    const filteredVariants = ValuesVariant.filter(
      (variant) => variant.visible === true
    );

    console.log("Filtered Variants:", filteredVariants);

    const allRowsSelected = selectedValues.every((variant) =>
      variant.value.some((val) => selectedCombination[variant.name] === val)
    );

    const variantsWithId = filteredVariants.map((variant, index) => ({
      ...variant,
      id: index + 1, // or use uuidv4() for unique id
    }));

    console.log("All Rows Selected:", allRowsSelected);

    if (allRowsSelected) {
      const matchedVariant = variantsWithId.find((variant) =>
        Object.keys(selectedCombination).every(
          (key) => variant[key] === selectedCombination[key]
        )
      );

      console.log("Matched Variant:", matchedVariant);

      if (matchedVariant) {
        setProductsRegular(matchedVariant.regular_price);
        setProductsSale(matchedVariant.sale_price);
        console.log("Price:", matchedVariant.regular_price);
        console.log("Sale Price:", matchedVariant.sale_price);

        setProductuniqueId(matchedVariant.id);
        setMatchImages(matchedVariant.images);

        const { regular_price, sale_price, qty, visible, images, id, ...rest } =
          matchedVariant;

        const restString = `[ ${Object.entries(rest)
          .map(([key, value]) => `${key}: ${value}`)
          .join(", ")} ]`;
        setProductVariantName(" " + restString);
      } else {
        console.log("No matching variant found for the selected combination.");
      }
    } else {
      console.log("Not all combinations selected.");
    }
  }, [selectedCombination]);

  const removeSelectedFillter = () => {
    setSelectedCombination([]);
    setMatchImages([]);
    setProductsRegular(0);
    setProductsSale(0);
    setProductVariantName("");
    toast.success("Attribute Cleared Successfully");
  };

  const isCombinationPossible = (name, value) => {
    const newSelectedCombination = { ...selectedCombination, [name]: value };

    const visibleVariants = ValuesVariant.filter((variant) => variant.visible);

    return visibleVariants.some((variant) =>
      Object.keys(newSelectedCombination).every(
        (key) =>
          !newSelectedCombination[key] ||
          variant[key] === newSelectedCombination[key]
      )
    );
  };

  const [EnquireShow, setEnquireShow] = useState(false);

  const [EnquireStatus, setEnquireStatus] = useState(false);

  

  const [StepForm, setStepForm] = useState(0);

  const handleNext = () => {
    setStepForm((prevStep) => prevStep + 1);
  };

  const handlePrevious = () => {
    setStepForm((prevStep) => prevStep - 1);
  };

  const [planStatus, setPlanStatus] = useState(false);

  const enquireToggle = () => {

    if (EnquireShow) {
      setEnquireShow(false);
    } else {
      GetUserPlan();
      setEnquireShow(true);
    }
  };
  const [ShareShow, setShareShow] = useState(false);
  const [ReferralStatus, setReferralStatus] = useState(false);

    const shareToggle = () => {

    if (ShareShow) {
      setShareShow(false);
    } else {
       setShareShow(true);
    }
  };

  

    const GetUserPlan = async () => {
      try {
        const decryptdatajson = await getDecryptData();
        const Id = decryptdatajson?._id;
  if(Id){
      const { data } = await axiosInstance.get(`check-plan-user/${Id}`);
  
        const { success, message } = data;
  
        if (success) {
         setPlanStatus(true);
        } else {
          toast.error(message);
          setPlanStatus(false)
          navigate('/all-plan')
        }
  
  }else{
    toast.error('Please Buy Plan');
    navigate('/checkout-plan/plan');
  }
       
  
      } catch (error) {
        console.log(error);
        navigate('/all-plan');
        // toast.error("Error fetching Single Blog!");
      }
    }
  

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const validate = (email) => {
    // Regular expression to check for invalid characters
    const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .

    // Check for invalid cases
    if (email === "-" || email === "+") {
      return "";
    } else if (invalidCharsRegex.test(email)) {
      return ""; // Return empty string if invalid characters (including spaces) are found
    } else {
      return email; // Return the original email if valid
    }
  };

  const [data, setData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [showHide, setShowHide] = useState(true);


 
   const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

   const fetchUserPhoneData = async (phone) => {
  if(phone.length === 10){
  
   try {
    const response = await axiosInstance.get(`/get-user-details?&type=none&filter=none&phone=${phone}`);
    const { success, Users } = response.data;
    if (success) {
      if(Users && Users[0]){
        const data = Users[0];
        
         setEnquireData((prevData) => ({
                ...prevData,
          referralId: data._id,
          referralName: data.username || '',
          referralEmail: data.email || '',
          referralPhone: data.phone || '',
         })); // Clear form fields

      }
      toast.success('User Found');
      console.log('Users',response.data);
      }else{
        toast.error('User Not Found');
        setEnquireData({
          referralId:  '',
          referralName:  '',
          referralEmail:  '',
          referralPhone:  '',
          Referral: '',
        });
      }

  } catch (error) {
    console.error('Error fetching User:', error);

  } 

}

};

  const [addressSuggestions, setAddressSuggestions] = useState([]);

  const [AllAddress, setAllAddress] = useState([]);

 

const handleAddressSelect = (suggestion) => {
  const placesService = new window.google.maps.places.PlacesService(document.createElement("div"));

  placesService.getDetails({ placeId: suggestion.place_id }, (place, status) => {
    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
      const fullAddress = place.formatted_address;
      const lat = place.geometry?.location?.lat();
      const lng = place.geometry?.location?.lng();

      // Update state
      setAllAddress([]); // Clear suggestions after selection

      setEnquireData((prevData) => ({
        ...prevData,
        address: fullAddress,
        latitude: lat,
        longitude: lng,
      }));

      console.log("Selected place:", {
        address: fullAddress,
        lat,
        lng,
        place,
      });
    }
  });
};


  const handleEnquireChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Determine the new value based on input type
    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Capitalize each word for specific fields
    if (name === "fullname") {
      newValue = capitalizeEachWord(newValue);
    }

    if (name === "email") {
      newValue = validate(newValue);
    }
 if (name === "Referral") {
      fetchUserPhoneData(newValue);
    }
 
    if (name === "phone") {
      // Replace non-digit characters
      newValue = value.replace(/\D/g, ""); // This allows only digits
      if (newValue.length > 13) {
        newValue = newValue.slice(0, 13); // Limit to 10 digits
      }
    }

  // Capitalize text for the 'username' field
  if (name === "state") {
    const selectedState = data.find((state) => state._id === newValue);
    if (selectedState) {
      setFilteredCities(selectedState.cities);
      setEnquireData((prevData) => ({
        ...prevData,
        statename: selectedState.name,
        city: "",
      }));
    }
    console.log("selectedState", selectedState, newValue, data);
  }

   if (name === "address") {
  const autocompleteService = new window.google.maps.places.AutocompleteService();

  // Get predictions based on the typed input
  autocompleteService.getPlacePredictions({ input: value }, (predictions, status) => {
    if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
      setAllAddress(predictions); // or setAddressSuggestions()
      console.log('predictions',predictions)
    }
  });

  // Optionally update the typed value in the form state
  setEnquireData((prevData) => ({
    ...prevData,
    address: value,
  }));
  return;  
}else{

    // Update form data with the new value
    setEnquireData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
}


  };

  const handleSendEnquire = async () => {
    console.log('enquireData',enquireData)

    const fields = [
      { name: "fullname", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "address", message: "Please enter address" },
      { name: "pincode", message: "Please enter Pincode" },
      { name: "state", message: "Please enter state" },
      { name: "city", message: "Please enter city" },
      { name: "bookingDate", message: "Please enter booking date" },
      { name: "bookingTime", message: "Please enter booking time" },
       { name: "latitude", message: "Please Select address" },
 
    ];

    for (const field of fields) {
      if (!enquireData[field.name]) {
        toast.error(field.message);
        setEnquireStatus(false);
        return;
      }
    }


       const FinalData = {
  ...enquireData,
  agentId: Product?.userId?._id || null
};
         
    try {
      setEnquireStatus(true);
      await toast.promise(axiosInstance.post(`/send-enquire`, FinalData), {
        loading: "Enquire Submiting...", // Loading message
        success: "Enquire Submited Successfully!", // Success message
        error: "Failed to Submit Enquire.", // Error message
      });
      enquireToggle();
      setEnquireData((prevData) => ({
        ...prevData,
        fullname: "",
        email: "",
        phone: "",
        service: "",
        QTY: "",
      })); // Clear form fields
      setShowHide(false);
    } catch (error) {
      console.error("Failed to send email:", error);
      // toast.error('Failed to send email');
            setShowHide(true);

    } finally {
      setEnquireStatus(false);
    }
  };


    const handleShareEnquire = async () => {
    console.log('enquireData',enquireData);
     

if (!enquireData.Referral || enquireData.Referral.length !== 10) {
  toast.error('Enter valid referral Phone No.');
  return null;
}
    const fields = [
      { name: "referralPhone", message: "Referral Source Required" },
      { name: "Referral", message: "Referral Source Phone No. Required" },
      { name: "fullname", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "address", message: "Please enter address" },
      { name: "pincode", message: "Please enter Pincode" },
      { name: "state", message: "Please enter state" },
      { name: "city", message: "Please enter city" },
     ];

    for (const field of fields) {
      if (!enquireData[field.name]) {
        toast.error(field.message);
        setReferralStatus(false);
        return;
      }
    }
 
      const FinalData = {
  ...enquireData,
  agentId: Product?.userId?._id || null
};
  
    try {
      setReferralStatus(true);
      await toast.promise(axiosInstance.post(`/send-referral-enquire`, FinalData), {
        loading: "Enquire Submiting...", // Loading message
        success: "Enquire Submited Successfully!", // Success message
        error: "Failed to Submit Enquire.", // Error message
      });
      enquireToggle();
      setEnquireData((prevData) => ({
        ...prevData,
        fullname: "",
        email: "",
        phone: "",
        service: "",
        QTY: "",
      })); // Clear form fields
      setShowHide(false);
    } catch (error) {
      console.error("Failed to send email:", error);
      // toast.error('Failed to send email');
      setShowHide(true);
    } finally {
      setReferralStatus(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);  

 

  return (
    <>

      <Header />



      <div
        className="modal enquire fade show"
        style={{ display: EnquireShow ? "block" : "none",backgroundColor:'#00000070' }}
        id="exampleModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header py-0 d-flex justify-content-between">
              <h5 className="modal-title" id="exampleModalLabel">
                Enquiry Now
              </h5>
              <button
                type="button"
                className="border-0 close bg-transparent h3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={enquireToggle}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">

              <div className="row">
                {StepForm === 0 && 
                <>
                 {/* Name input */}
                 <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example1">
                    Full Name <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={enquireData.fullname}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>
                {/* Email input */}
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Phone No. <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="number"
                    id="form5Example2"
                    className="form-control"
                    name="phone"
                    value={enquireData.phone}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Email address{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={enquireData.email}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

          

                </>}
               
                {StepForm === 1 && 
                <>
                <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5address">
                  Full Address
                    <span className="text-danger"> (Required )</span>
                  </label>
                  
                   <input
                    type="text"
                    id="address"
                    className="form-control"
                    name="address"
                    value={enquireData.address}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />

                </div>

 {AllAddress.map((suggestion) => (
  <div

    key={suggestion.place_id}
    onClick={() => handleAddressSelect(suggestion)}
    className="suggestion-item col-12"
  >
    <div className="p-2 border-bottom">
 {suggestion.description}
    </div>
   
  </div>
))}


                <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Pincode
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    id="pincode"
                    className="form-control"
                    name="pincode"
                    value={enquireData.pincode}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

   <div className="mb-4 col-6  ">
                  <label className="form-label text-dark" htmlFor="email">
                    State <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <select
                      className="form-control"
                      id="state"
                      name="state"
                      value={enquireData.state}
                      onChange={handleEnquireChange}
                    >
                      <option selected disabled>
                        {" "}
                        {loading ? "Loading..." : "Select State"}
                      </option>
                      {data.length !== 0 && data.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      ))}{" "}
                      ;
                    </select>
                  </div>
                </div>

                <div className="mb-4 col-6 ">
                  <label className="form-label text-dark" htmlFor="city">
                    City <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <select
                      className="form-control"
                      id="city"
                      name="city"
                      value={enquireData.city}
                      onChange={handleEnquireChange}
                    >
                      <option selected value={""}>
                        {" "}
                     Select City 
                      </option>
                      {Array.isArray(filteredCities) && filteredCities.length > 0 && (
  filteredCities.map((city, index) => (
    <option key={index} value={city}>
      {city}
    </option>
  ))
)}

                    </select>
                  </div>
                </div>

                {Array.isArray(Product?.userId?.coverage) && Product?.userId?.coverage.length > 0 && (
    <>
 
    <p className="m-0 text-danger"> This product is availabe in :</p>
    <div>
      
    {  Product?.userId?.coverage.map((city, index) => (
      <span
        key={index}
        className="badge bg-dark me-1"
        >
        {city}  
      </span>
    ))}
    
    </div>
    </> 
  )  }
  
</>
}

{StepForm === 2 && <>
  <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                  Booking Date
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="date"
                    id="form5Example2"
                    className="form-control"
                    name="bookingDate"
                    value={enquireData.bookingDate}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>
 
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                     Booking Time
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="time"
                    id="form5Example2"
                    className="form-control"
                    name="bookingTime"
                    value={enquireData.bookingTime}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

  <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Requirement{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <textarea
                    type="text"
                    id="requirement"
                    className="form-control"
                    name="requirement"
                    value={enquireData.requirement}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                  <input
                    type="text"
                    id="service"
                    value={Product?.title}
                    className="form-control d-none"
                    style={{ boxShadow: "none" }}
                  />
                     <input
                    type="text"
                    id="category"
                    value={Product?.Category}
                    className="form-control d-none"
                    style={{ boxShadow: "none" }}
                  />
                </div>
</> }
         
 
  
 

              </div>
            </div>
            <div className="modal-footer">

            {StepForm === 0 && <>
               <button  type="button"
                className="btn btn-primary"
                onClick={handleNext} >
                Next
              </button>
                </>
                 }

          {StepForm === 1 && <>
              <button  type="button"
                className="btn btn-secondary"
                onClick={handlePrevious} >
                Previous
              </button>
               <button  type="button"
                className="btn btn-primary"
                onClick={handleNext} >
                Next
              </button>
                </>
                 }

                {StepForm === 2 &&   <>
                  <button  type="button"
                className="btn btn-secondary"
                onClick={handlePrevious} >
                Previous
              </button>
              {/* <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={enquireToggle}
              >
                Close
              </button> */}
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSendEnquire}
                disabled={EnquireStatus} // Properly use the `disabled` attribute
              >
                Submit
              </button>
              </> }

            </div>
          </div>
        </div>
      </div>


                
  <div
    className="modal fade show"
    id="shareModel"
    tabIndex={-1}
    aria-labelledby="shareModelLabel"
    aria-hidden="true"
  style={{ display: ShareShow ? "block" : "none",backgroundColor:'#00000070' }}

  >
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title fw-light" id="shareModelLabel">
            Share Lead
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
               onClick={shareToggle}
          />
        </div>
        <div className="modal-body"> <div className="row">



                {StepForm === 0 && 
                <>
               {/* Name input */}
                 <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="Referral">
                    Referral Source (Your Phone no.) <span className="text-danger"> (Required )</span>
                  </label>
                   
                  <input
                    type="number"
                    name="Referral"
                    id="Referral"
                    className="form-control"
                    value={enquireData.Referral}
                     style={{ boxShadow: "none" }}
                     onChange={(e) => {
                        if (e.target.value.length <= 10) {
                          // Check input length before updating
                          handleEnquireChange(e); // Call handleChange if length is within limit
                        }
                      }}
                      onInput={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length <= 10) {
                          setEnquireData({ ...enquireData, Referral: inputValue });
                        }
                      }}

                  />
                </div>

                {enquireData.referralName && 
                  <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="Referral">
                    Referral Source (Full Name)  
                  </label>
                  <input
                    type="Text"
                    name="referralName"
                    id="referralName"
                    className="form-control"
                    value={enquireData.referralName}
                     style={{ boxShadow: "none" }}
                     disabled

                  />
                </div>
                }
                <hr/>

                 {/* Name input */}
                 <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example1">
                    Full Name <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={enquireData.fullname}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>
                {/* Email input */}
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Phone No. <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="number"
                    id="form5Example2"
                    className="form-control"
                    name="phone"
                    value={enquireData.phone}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Email address{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={enquireData.email}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

          

                </>}
               
                {StepForm === 1 && 
                <>
                <div  className="form-outline col-md-12 mb-2">
                  <label className="form-label" htmlFor="form5address">
                  Full Address
                    <span className="text-danger"> (Required )</span>
                  </label>
                  
                   <input
                    type="text"
                    id="address"
                    className="form-control"
                    name="address"
                    value={enquireData.address}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />

                </div>
 
               {AllAddress.map((suggestion) => (
  <div

    key={suggestion.place_id}
    onClick={() => handleAddressSelect(suggestion)}
    className="suggestion-item col-12"
  >
    <div className="p-2 border-bottom">
 {suggestion.description}
    </div>
   
  </div>
))}


                <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Pincode
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    id="pincode"
                    className="form-control"
                    name="pincode"
                    value={enquireData.pincode}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

   <div className="mb-4 col-6  ">
                  <label className="form-label text-dark" htmlFor="email">
                    State <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <select
                      className="form-control"
                      id="state"
                      name="state"
                      value={enquireData.state}
                      onChange={handleEnquireChange}
                    >
                      <option selected disabled>
                        {" "}
                        {loading ? "Loading..." : "Select State"}
                      </option>
                      {data.length !== 0 && data.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      ))}{" "}
                      ;
                    </select>
                  </div>
                </div>

                <div className="mb-4 col-6 ">
                  <label className="form-label text-dark" htmlFor="city">
                    City <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <select
                      className="form-control"
                      id="city"
                      name="city"
                      value={enquireData.city}
                      onChange={handleEnquireChange}
                    >
                      <option selected value={""}>
                        {" "}
                     Select City 
                      </option>
                      {Array.isArray(filteredCities) && filteredCities.length > 0 && (
  filteredCities.map((city, index) => (
    <option key={index} value={city}>
      {city}
    </option>
  ))
)}

                    </select>
                  </div>
                </div>

                {Array.isArray(Product?.userId?.coverage) && Product?.userId?.coverage.length > 0 && (
    <>
 
    <p className="m-0 text-danger"> This product is availabe in :</p>
    <div>
      
    {  Product?.userId?.coverage.map((city, index) => (
      <span
        key={index}
        className="badge bg-dark me-1"
        >
        {city}  
      </span>
    ))}
    
    </div>
    </> 
  )  }
  
</>
}

 
         
 
  
 

              </div>
            </div>
            <div className="modal-footer">

            {StepForm === 0 && <>
               <button  type="button"
                className="btn btn-primary"
                onClick={handleNext} >
                Next
              </button>
                </>
                 }

          {StepForm === 1 && <>
              <button  type="button"
                className="btn btn-secondary"
                onClick={handlePrevious} >
                Previous
              </button>
            <button
                type="button"
                className="btn btn-primary"
                onClick={handleShareEnquire}
                disabled={ReferralStatus} // Properly use the `disabled` attribute
              >
                Submit
              </button>
                </>
                 }
 

            </div>
      </div>
    </div>
  </div>
 


      <div className="breadcrumb-bar text-center">
  <div className="container">
    <div className="row">
      <div className="col-md-12 col-12">
        <h2 className="breadcrumb-title mb-2">Service Details</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb justify-content-center mb-0">
            <li className="breadcrumb-item">
              <a href="https://truelysell-laravel.dreamstechnologies.com">
                <i className="ti ti-home-2" />
              </a>
            </li>
            <li className="breadcrumb-item">Services</li>
            <li className="breadcrumb-item active" aria-current="page">
              Service Details
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</div>


     <div className="container" style={{ transform: "none" }}>
      <div className="row" style={{ transform: "none" }}>
        <div className="col-xl-8">
          <div className="card border-0">
            <div className="card-body">
              <div className="service-head mb-2">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <h3 className="mb-2">{Product.title}</h3>
                  
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
                  <div className="d-flex align-items-center flex-wrap">
                    
                    <p className="mb-2">
                      <i className="ti ti-star-filled text-warning me-2" />
                      
                      {!averageRating || (!totalRating && !isLoading) ? (
                      <>
                        <span className="text-gray-9">0 </span>(0 reviews)  
                      </>
                    ) : (
                      <>
                      <span className="text-gray-9">{averageRating}  </span>({totalRating} reviews)  
                         
                      </>
                    )}
                    </p>
                  </div>
                   
                </div>
              </div>
              <div className="service-wrap mb-4">
            
              {frontImage && (
                  <>
                    <div className={`${MatchImages.length === 0 && "d-none"}`}>
                      <Swiper
                        onClick={togglePopup}
                        style={{
                          "--swiper-navigation-color": "#335599",
                          "--swiper-pagination-color": "#335599",
                        }}
                        spaceBetween={10}
                        navigation={true}
                        thumbs={{ swiper: thumbsVarSwiper }}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className={`mySwiper2 hide-desk-pagenation ${isLoading && "d-none"
                          } `}
                      >
                        {MatchImages.map((imageUrl, index) => (
                          <SwiperSlide key={index}>
                            <div
                              style={{
                                aspectRatio: "1 / 1",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={imageUrl.src}
                                onMouseEnter={() =>
                                  handleMouseEnter(imageUrl.src)
                                }
                                onMouseLeave={handleMouseLeave}
                                onMouseMove={handleMouseMove}
                                className="m-auto d-block"
                                alt="Product Image"
                                style={{
                                  height: "100%",
                                  width: "auto",
                                  objectFit: "cover",
                                  cursor: "url(/assets/img/zoomm.png), auto",
                                  aspectRatio:'1/1',
                                }}
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                  
                      <Swiper
                        onSwiper={setThumbsVarSwiper}
                        spaceBetween={10}
                        slidesPerView={4}
                        freeMode={true}
                        watchSlidesProgress={true}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className={`mySwiper mt-4 ${isLoading && "d-none"}   `}
                      >
                        {MatchImages.map((imageUrl, index) => (
                          <SwiperSlide key={index}>
                            <img
                              src={imageUrl.src}
                              alt="Product Image"
                              style={{
                                aspectRatio: "1 / 1",
                                objectFit: "cover",
                              }}
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </>
                )}

                {frontImage && (
                  <>
                    <div className={`${MatchImages.length !== 0 && "d-none"}`}>
                      <Swiper
                        onClick={togglePopup}
                        style={{
                          "--swiper-navigation-color": "#335599",
                          "--swiper-pagination-color": "#335599",
                        }}
                        spaceBetween={10}
                        navigation={true}
                        thumbs={{ swiper: thumbsSwiper }}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className={`mySwiper2 hide-desk-pagenation ${isLoading && "d-none"
                          }  ${MatchImages.length !== 0 && "d-none"}`}
                      >
                        <SwiperSlide>
                          <div
                            style={{
                              aspectRatio: "1 / 1",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={frontImage}
                              onMouseEnter={() => handleMouseEnter(frontImage)}
                              onMouseLeave={handleMouseLeave}
                              onMouseMove={handleMouseMove}
                              className="m-auto d-block"
                              alt="Product Image"
                              style={{
                                height: "100%",
                                width: "auto",
                                objectFit: "cover",
                                cursor: "url(/assets/img/zoomm.png), auto",
                                aspectRatio:'1/1',
                              }}
                            />
                          </div>
                        </SwiperSlide>

                        {Images.map((imageUrl, index) => (
                          <SwiperSlide key={index}>
                            <div
                              style={{
                                aspectRatio: "1 / 1",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={imageUrl}
                                onMouseEnter={() => handleMouseEnter(imageUrl)}
                                onMouseLeave={handleMouseLeave}
                                onMouseMove={handleMouseMove}
                                className="m-auto d-block"
                                alt="Product Image"
                                style={{
                                  height: "100%",
                                  width: "auto",
                                  objectFit: "cover",
                                  cursor: "url(/assets/img/zoomm.png), auto",
                                  aspectRatio:'1/1',
                                }}
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                      <Swiper
                        onSwiper={setThumbsSwiper}
                        spaceBetween={10}
                        slidesPerView={4}
                        freeMode={true}
                        watchSlidesProgress={true}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className={`mySwiper mt-4 ${isLoading && "d-none"}  `}
                      >
                        <SwiperSlide>
                          <img
                            src={frontImage}
                            alt="Product Image"
                            style={{
                              aspectRatio: "1 / 1",
                              objectFit: "cover",
                            }}
                          />
                        </SwiperSlide>

                        {Images.map((imageUrl, index) => (
                          <SwiperSlide key={index}>
                            <img
                              src={imageUrl}
                              alt="Product Image"
                              style={{
                                aspectRatio: "1 / 1",
                                objectFit: "cover",
                              }}
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </>
                )}

                {isLoading && (
                  <>
                    <div
                      className="card-1 skeleton"
                      style={{ height: 480, borderRadius: 20 }}
                    ></div>
                  </>
                )}
                
                              </div>
              <div className="accordion service-accordion">
                <div className="accordion-item mb-4">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button p-0"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#overview"
                      aria-expanded="false"
                    >
                      Service Overview
                    </button>
                  </h2>
                  <div
                    id="overview"
                    className="accordion-collapse collapse show"
                  >
                    <div className="accordion-body border-0 p-0 pt-3">

                      <hr/>

                      <div className="bg-light-200 p-3 offer-wrap">
													<h4 className="mb-3">Services Offered</h4>
													
													 
												
														{!isLoading && selectedValues && selectedValues.length > 0 && (
  <>
    {selectedValues.map((variant, index) => (
      <div
        key={index}
        className="offer-item d-md-flex align-items-center justify-content-between bg-white mb-2"
      >
        <div className="d-sm-flex align-items-center mb-2">
          <div className="mb-2">
            <h6 className="fs-16 fw-medium">
              {variant.title || variant.name}
            </h6>
            <p className="fs-14">
              {variant?.value.length > 0 &&
                                  variant?.value.map((value, idx) => {
                                    const isActive =
                                      selectedCombination[variant.name] ===
                                      value;
                                    const isDisabled = !isCombinationPossible(
                                      variant.name,
                                      value
                                    );
                                    return  value + ', '
                                  })}
                                 </p>
          </div>
        </div>
        <div className="pb-3">
          <h6 className="fs-16 fw-medium text-primary mb-0">
            ₹{ProductsSale || "0.00"}
          </h6>
        </div>
      </div>
    ))}
  </>
)}

                            
																									</div>


 


                      <div className="p-3 rounded" style={{backgroundColor:'#fafafa '}}>
                      <div
                    dangerouslySetInnerHTML={{ __html: Product?.description }}
                  />
                      </div>
                  

                                
                   
 
                   

                    </div>
                  </div>
                </div>
                
                
              </div>
            </div>
          </div>
          <div className="card border-0 mb-xl-0 mb-4">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <h4 className="mb-3" id="total_review_count">
                  Reviews (1)
                </h4>

                 {/* {!hasUserReviewed() && (
                        <button
                          className="nav-link btn btn-light"
                          type="button"
                          onClick={toggleReviewPopup}
                        >
                          <i className="ri-add-line me-1" />
                          Write a Review
                        </button>
                      )}
                       */}

 <button
                          className="nav-link btn btn-light"
                          type="button"
                          onClick={toggleReviewPopup}
                        >
                          <i className="ri-add-line me-1" />
                          Write a Review
                        </button>

                      
                      {isOpenReview && (
                        <>
                          <div className="custom-popup " >
                            <div className="popup-container ">
                              <button
                                className="btn btn-danger btn-sm d-flex align-items-center justify-content-center p-1 fs-4 rounded-circle"
                                type="button"
                                onClick={toggleReviewPopup}
                              >
                                
                                <i className="ti ti-x"/>
                              </button>

                              <div className="card border-0">
                                <div className="card-body border-0">
                                  <h4 className="mb-2">Review And Rating</h4>
                                  <div className="needs-validation">
                                    <div className="mb-4">
                                      <label
                                        className="form-label"
                                        htmlFor="review-rating"
                                      >
                                        How was your experience about our
                                        product?
                                      </label>

                                      <div className="d-flex gap-2 ratingbox">
                                        <input
                                          type="radio"
                                          onChange={handleChange}
                                          name="rating"
                                          id="rating5"
                                          defaultValue="5"
                                          className="d-none"
                                        />
                                        <label htmlFor="rating5">
                                          <i className="ti ti-star-filled" />{" "}
                                        </label>

                                        <input
                                          type="radio"
                                          onChange={handleChange}
                                          name="rating"
                                          id="rating4"
                                          defaultValue="4"
                                          className="d-none"
                                        />
                                        <label htmlFor="rating4">
                                          <i className="ti ti-star-filled" />{" "}
                                        </label>

                                        <input
                                          type="radio"
                                          onChange={handleChange}
                                          name="rating"
                                          id="rating3"
                                          defaultValue="3"
                                          className="d-none"
                                        />
                                        <label htmlFor="rating3">
                                          <i className="ti ti-star-filled" />{" "}
                                        </label>

                                        <input
                                          type="radio"
                                          onChange={handleChange}
                                          name="rating"
                                          id="rating2"
                                          defaultValue="2"
                                          className="d-none"
                                        />
                                        <label htmlFor="rating2">
                                          <i className="ti ti-star-filled" />{" "}
                                        </label>

                                        <input
                                          type="radio"
                                          onChange={handleChange}
                                          name="rating"
                                          id="rating1"
                                          defaultValue="1"
                                          className="d-none"
                                        />
                                        <label htmlFor="rating1">
                                          <i className="ti ti-star-filled" />{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="mb-4">
                                      <label
                                        className="form-label"
                                        htmlFor="review-text"
                                      >
                                        Review<span>*</span>
                                      </label>
                                      <textarea
                                        className="form-control"
                                        rows={5}
                                        maxLength={300}
                                        name="comment"
                                        id="review-text"
                                        value={formData.comment}
                                        onChange={handleChange}
                                      />
                                      <div className="invalid-feedback">
                                        Please leave your review.
                                      </div>
                                    </div>

                                    {SubmitLoading ? (
                                      <button
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={submitData}
                                      >
                                        Add Review
                                      </button>
                                    ) : (
                                      <button
                                        className="btn btn-secondary btn-sm"
                                        type="button"
                                        disabled
                                      >
                                        <span className="ms-1">Loading...</span>
                                        <span
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      
                 
              </div>
              <div className="row align-items-center">
                <div className="col-md-5">
                  <div className="rating-item bg-light-500 text-center mb-3">
                    <h5 className="mb-3">Customer Reviews &amp; Ratings</h5>
                    <div
                      className="d-inline-flex align-items-center justify-content-center"
                      id="stars_container"
                    >
                      <i className="ti ti-star-filled text-warning me-1" />
                      <i className="ti ti-star-filled text-warning me-1" />
                      <i className="ti ti-star-filled text-warning me-1" />
                      <i className="ti ti-star-filled text-warning me-1" />
                      <i className="ti ti-star-filled text-warning me-1" />
                    </div>
                    <p className="mb-3" id="avg_rating">
                          
                       {!averageRating || (!totalRating && !isLoading) ? (
                      <>
                        
                          0 by 0 Reviews
                        
                      </>
                    ) : (
                      <>
                     
                          {averageRating} by {totalRating} Reviews
                       
                      </>
                    )}

                    </p>
                    <p className="text-gray-9" id="totalReviewCount">
                      Basedon 1 Reviews
                    </p>
                  </div>
                </div>
                <div className="col-md-7">

                    


                  <div
                    className="rating-progress mb-3"
                    id="review_progress_container"
                  >
                    <div className="d-flex align-items-center mb-2">
                      <p className="me-2 text-nowrap mb-0">5 Star Ratings</p>
                      <div
                        className="progress w-100"
                        role="progressbar"
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-warning"
                          style={{ width: totalRating === 5 && '100%' }}
                        />
                      </div>
                      <p className="progress-count ms-2">{totalRating === 5 ? ratings.length : 0 }</p>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <p className="me-2 text-nowrap mb-0">4 Star Ratings</p>
                      <div
                        className="progress w-100"
                        role="progressbar"
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-warning"
                         style={{ width: totalRating === 4 && '100%' }}

                        />
                      </div>
                      <p className="progress-count ms-2">{totalRating === 4 ? ratings.length : 0 }</p>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <p className="me-2 text-nowrap mb-0">3 Star Ratings</p>
                      <div
                        className="progress w-100"
                        role="progressbar"
                        aria-valuenow={100}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-warning"
                          style={{ width: totalRating === 3 && '100%' }}
                        />
                      </div>
                      <p className="progress-count ms-2">{totalRating === 3 ? ratings.length : 0 }</p>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <p className="me-2 text-nowrap mb-0">2 Star Ratings</p>
                      <div
                        className="progress w-100"
                        role="progressbar"
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-warning"
                          style={{ width: totalRating === 2 && '100%' }}
                        />
                      </div>
                      <p className="progress-count ms-2">{totalRating === 2 ? ratings.length : 0 }</p>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <p className="me-2 text-nowrap mb-0">1 Star Ratings</p>
                      <div
                        className="progress w-100"
                        role="progressbar"
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <div
                          className="progress-bar bg-warning"
                          style={{ width: totalRating === 1 && '100%' }}
                        />
                      </div>
                      <p className="progress-count ms-2"> {totalRating === 1 ? ratings.length : 0 }</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="list-reviews">
                <div className="card review-item mb-3">
                  
                     
 {ratings.length === 0 ? (
                        <p className="p-2 text-center">No reviews found.</p> // Render message if no reviews are available
                      ) : (
                        ratings.map((rating, index) => (
 
                  <div key={index} className="card-body p-3 review_item" id="reply_38">
                    <div className="review-info">
                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <div className="d-flex align-items-center mb-2">
                          <span className="avatar avatar-lg me-2 flex-shrink-0">
                            <img
                              src="/assets/img/user.png"
                              className="rounded-circle"
                              alt="img"
                            />
 
                          </span>
                          <div>
                            <h6 className="fs-16 fw-medium">{rating.username || ""}</h6>
                            <div className="d-flex align-items-center flex-wrap date-info">
                              <p className="fs-14 mb-0"> {formatDate(rating.createdAt)}{" "}</p>
                            </div>
                          </div>
                        </div>
                        <span className="badge bg-success d-inline-flex align-items-center mb-2">
                          <i className="ti ti-star-filled me-1" />{rating.rating}
                        </span>
                      </div>
                      <p className="mb-2">{rating.comment || ""}</p>
                       
                    </div>
                    
                  </div>

                        )))}

                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-xl-4 theiaStickySidebar"
          style={{
            position: "relative",
            overflow: "visible",
            boxSizing: "border-box",
            minHeight: 1
          }}
        >
          <div
            className="theiaStickySidebar"
            style={{
              paddingTop: 0,
              paddingBottom: 1,
              position: "static",
              transform: "none",
              top: 0,
              left: "997.588px"
            }}
          >
            <div className="card border-0">
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                  <div className="d-flex align-items-center">
                    <div className="mb-3">
                    <div className="col-auto d-flex flex-column justify-content-center">
                              <span className="text-accent fs-2">
                                ₹{ProductsSale} {' '}
                                <del className="text-accent fs-3 text-danger">
                                   ₹{ProductsRegular} 
                              </del>
                              </span>
                                  
                            </div>
                           
                            <div className="text-danger  mt-n1">
                                You save{" "}
                                {Math.round(
                                  ((ProductsRegular - ProductsSale) /
                                    ProductsRegular) *
                                  100
                                )}
                                % (₹{ProductsRegular - ProductsSale})
                              </div>

                    </div>
                  </div>
                </div>
                {/* <form enctype="multipart/form-data" method="POST" action="https://truelysell-laravel.dreamstechnologies.com/book">
													<h4 className="mb-3">Services Offered</h4>
							

								<div className="d-flex align-items-center justify-content-between mb-3">
									<h6 className="fs-16 fw-medium mb-0">
										<input className="form-check-input" name="service_offer[]" type="checkbox" value="Bike Service_10.00"> Bike Service									</h6>
									<p>Mad10.00</p>
								</div>
																	<a className="nav-link btn btn-light" href="#" data-bs-toggle="modal" data-bs-target="#login-modal"><i className="ti ti-calendar me-2"></i>Book Service</a>
									</div>
			</div>
			<!-- my booking */}

{isLoading ? (
                    <>
                      <div
                        className="card-1 skeleton mb-2"
                        style={{
                          height: 50,
                          width: 400,
                          maxWidth: "100%",
                          borderRadius: 10,
                        }}
                      ></div>
                    </>
                  ) : (
                    <div className="w-100">
                      <div className="quantity-products mb-3 ">
                        
                        <button
                          className="btn btn-primary w-100"
                          type="button"
                          data-toggle="modal"
                          data-target="#exampleModal"
                          onClick={enquireToggle}
                        >
                          <i className="ri-mail-send-fill"></i>
                          <span className="ms-2">Enquiry Now</span>
                        </button>
                      </div>

                      {/* <div className="quantity-products d-flex justify-content-center d-none">
                        <button
                          className="quantity-btn-minus "
                          onClick={handleDecrement}
                        >
                          <i className="ri-subtract-line" />
                        </button>
                        <input
                          id="quantityNumber1"
                          className="quantity-number"
                          type="number"
                          value={TotalQuantity}
                          maxLength={Product?.stock}
                          onChange={handleQuantityChange}
                        />
                        <button
                          className="quantity-btn-plus"
                          onClick={() =>
                            handleIncrement(Product && Product?.stock)
                          }
                        >
                          <i className="ri-add-line" />
                        </button>
                      </div>

                      <div className="d-flex gap-2 justify-content-between ps-3 buy-float">
                        <button
                          disabled={Product?.stock === 0}
                          className="btn btn-primary d-flex align-items-center justify-content-center w-100"
                          type="button"
                          onClick={() => {
                            if (Product.type) {
                              if (ProductsSale === 0) {
                                toast.error("Please Choose Attribute");
                              } else {
                                handleAddToCart({
                                  id: Product._id + ProductuniqueId,
                                  title: Product.title + ProductVariantName,
                                  image:
                                    MatchImages.length !== 0
                                      ? MatchImages[0].src
                                      : frontImage, // Remove the extra dot
                                  regularPrice: ProductsRegular,
                                  price: ProductsSale,
                                  color: selectedColor,
                                  customise: pdfBase64,
                                  TotalQuantity: TotalQuantity,
                                  SelectedSizes: SelectedSizes,
                                  weight: Product.weight,
                                  gst: Product.gst,
                                  stock: Product.stock,
                                  pid: Product._id,
                                });
                              }
                            } else {
                              handleAddToCart({
                                id: Product._id + ProductuniqueId,
                                title: Product.title + ProductVariantName,
                                image:
                                  MatchImages.length !== 0
                                    ? MatchImages[0].src
                                    : frontImage, // Remove the extra dot
                                regularPrice: ProductsRegular,
                                price: ProductsSale,
                                color: selectedColor,
                                customise: pdfBase64,
                                TotalQuantity: TotalQuantity,
                                SelectedSizes: SelectedSizes,
                                weight: Product.weight,
                                gst: Product.gst,
                                stock: Product.stock,
                                pid: Product._id,
                              });
                            }
                          }}
                        >
                          <i className="ri-shopping-cart-2-line" />
                          <span className="ms-2">Add To Cart</span>
                        </button>

                        <button
                          className="btn bg-dark text-white d-flex align-items-center justify-content-center w-100"
                          type="button"
                          onClick={() => {
                            if (Product.type) {
                              if (ProductsSale === 0) {
                                toast.error("Please Choose Attribute");
                              } else {
                                handleBuyNow({
                                  id: Product._id + ProductuniqueId,
                                  title: Product.title + ProductVariantName,
                                  image:
                                    MatchImages.length !== 0
                                      ? MatchImages[0].src
                                      : frontImage, // Remove the extra dot
                                  regularPrice: ProductsRegular,
                                  price: ProductsSale,
                                  color: selectedColor,
                                  customise: pdfBase64,
                                  TotalQuantity: TotalQuantity,
                                  SelectedSizes: SelectedSizes,
                                  weight: Product.weight,
                                  gst: Product.gst,
                                  stock: Product.stock,
                                  pid: Product._id,
                                });
                              }
                            } else {
                              handleBuyNow({
                                id: Product._id + ProductuniqueId,
                                title: Product.title + ProductVariantName,
                                image:
                                  MatchImages.length !== 0
                                    ? MatchImages[0].src
                                    : frontImage, // Remove the extra dot
                                regularPrice: ProductsRegular,
                                price: ProductsSale,
                                color: selectedColor,
                                customise: pdfBase64,
                                TotalQuantity: TotalQuantity,
                                SelectedSizes: SelectedSizes,
                                weight: Product.weight,
                                gst: Product.gst,
                                stock: Product.stock,
                                pid: Product._id,
                              });
                            }
                          }}
                        >
                          <i className="ri-shopping-cart-2-line text-white" />
                          <span className="d-sm-inline ms-2 text-white">
                            Buy Now
                          </span>
                        </button>
                      </div> */}
                    </div>
                  )} 



                <div className="card border-0">
                  <div className="card-body">
                    <h4 className="mb-3">Service Provider</h4>
                    <div className="provider-info text-center bg-light-500 p-3 mb-3">
                      <div className="avatar avatar-xl mb-3">
                        <img
                          src="https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png"
                          alt="img"
                          className="img-fluid rounded-circle"
                        />
                        <span className="service-active-dot">
                          <i className="ti ti-check" />
                        </span>
                      </div>
                      <h5> {Product?.userId?.username}  </h5>
                      <p className="fs-14">
                        <i className="ti ti-star-filled text-warning me-2" />
                        <span className="text-gray-9 fw-semibold">3.0</span> (1
                        reviews)
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fs-16 fw-medium mb-0">
                        <i className="ti ti-user text-default me-2" />
                        Member Since 
                      </h6>
                      <p>{formatDate(Product?.userId?.createdAt)}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fs-16 fw-medium mb-0">
                        <i className="ti ti-map-pin me-1" />
                        Address
                      </h6>
                      <p>{Product?.userId?.address}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fs-16 fw-medium mb-0">
                        <i className="ti ti-mail me-1" />
                        Email
                      </h6>
                      <p>{!showHide ? Product?.userId?.email : (
                         <button
                          className="btn btn-dark btn-sm"
                          type="button"
                          data-toggle="modal"
                          data-target="#exampleModal"
                          onClick={enquireToggle}
                        >
                          <i className="ti ti-eye"></i>
                          <span className="ms-2">Show</span>
                        </button>
                      )}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fs-16 fw-medium mb-0">
                        <i className="ti ti-phone me-1" />
                        Phone
                      </h6>
                      <p> {!showHide ? Product?.userId?.phone : (
                         <button
                          className="btn btn-dark btn-sm"
                          type="button"
                          data-toggle="modal"
                          data-target="#exampleModal"
                          onClick={enquireToggle}
                        >
                          <i className="ti ti-eye"></i>
                          <span className="ms-2">Show</span>
                        </button>
                      )}   </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fs-16 fw-medium mb-0">
                        <i className="ti ti-file-text me-1" />
                        No of Listings
                      </h6>
                      <p>7</p>
                    </div>
                  </div>
                </div>

            
                      <div className="card border-0">
                  <div className="card-body">
                    <h4 className="mb-3"> Share Lead</h4>
                    <div className="map-wrap">
<p>By sharing leads, you can earn coins as a reward. Once you've collected enough coins, you can redeem them for exciting offers, discounts, or other benefits.

</p>
 
  <button
    type="button"
    className="btn btn-primary"
     bs-toggle="modal"
     bs-target="#shareModel"
      onClick={shareToggle}

  >
    Share Now
  </button>
  
           </div>
                       </div>

                        </div>
                         
                <div className="card border-0">
                  <div className="card-body">
                    <h4 className="mb-3">Location</h4>
                    <div className="map-wrap">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6509170.989457427!2d-123.80081967108484!3d37.192957227641294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2sin!4v1669181581381!5m2!1sen!2sin"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        className="contact-map"
                      />
                      <div className="map-location bg-white d-flex align-items-center">
                        <div className="d-flex align-items-center me-2">
                          <div className="ms-2 overflow-hidden">
                            <p className="two-line-ellipsis">
                              12301 Lake Underhill Rd, Suite 126, Orlando, 32828
                            </p>
                          </div>
                        </div>
                        <span>
                          <i className="feather-send fs-16" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="resize-sensor"
              style={{
                position: "absolute",
                inset: 0,
                overflow: "hidden",
                zIndex: -1,
                visibility: "hidden"
              }}
            >
              <div
                className="resize-sensor-expand"
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  overflow: "hidden",
                  zIndex: -1,
                  visibility: "hidden"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    transition: "all",
                    width: 450,
                    height: 2070
                  }}
                />
              </div>
              <div
                className="resize-sensor-shrink"
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  overflow: "hidden",
                  zIndex: -1,
                  visibility: "hidden"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    transition: "0s",
                    width: "200%",
                    height: "200%"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  

   

      <Footer />
    </>
  );
};

export default ProductSlug;
